import React from "react";
import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as InfoIcon } from "./assets/info-hexagon.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/arrow-right-white.svg";

interface PendingInvoiceAlertProps {
  text: string;
  onCompletePayment: () => void;
}

export const PendingInvoiceAlert: React.FC<PendingInvoiceAlertProps> = ({
  text,
  onCompletePayment,
}) => {
  const { t } = useTranslations();

  return (
    <div className="flex items-center justify-between bg-grey-100 px-8 py-4">
      <div className="flex items-center gap-3">
        <InfoIcon className="shrink-0" />
        <span className="font-secondary text-sm leading-[1.4] text-dark">
          {text}
        </span>
      </div>
      <Button
        size="sm"
        iconEnd={<ArrowRightIcon />}
        onClick={onCompletePayment}
      >
        {t({
          id: "cx-plans-page.pending-invoice-alert.complete-payment",
          defaultMessage: "Complete Payment",
        })}
      </Button>
    </div>
  );
};
